import React, { Component } from 'react';
import '../styles.css';
import Board from '../COMPONENTS/Board';
import { Background } from '../COMPONENTS/Background';
import BackButton from '../COMPONENTS/BackButton';
import { connect } from 'react-redux';
import { HIDDEN } from '../../HOME/const';
import * as f from '../logic';
import { updateStats } from '../REDUX/actions';
import { requestResetStats, requestSurrender } from '../../HOME/REDUX/actions';
import Leaderboard from '../COMPONENTS/Leaderboard';
import { HIDE, FADE, SHOW } from '../../HOME/const';
import Options from '../COMPONENTS/Options';
import Toolbar from '../COMPONENTS/Toolbar';
import TopBar from '../COMPONENTS/TopBar';
import { delay, dbset, dbget } from '../../HOME/utils';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { SEEN_OPTIONS_KEY } from '../const';

class GamePage extends Component {
  state = { options: HIDDEN };
  board = React.createRef();

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    dbget(SEEN_OPTIONS_KEY, seen => {
      if (!seen) {
        this.setState({ options: SHOW });
        dbset(SEEN_OPTIONS_KEY, true);
      }
    });

    f.getStats(this.props, stats => {
      this.props.updateStats(stats);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleClick = e => {
    let id = e.target.id;

    if (!id) {
      id = e.target.parentElement.id;
    }

    if (id !== 'options-button' && !id.startsWith('volume-')) {
      this.hideOptions();
    }
  };

  handleOptions = e => {
    this.props.requestResetStats(false);
    this.props.requestSurrender(false);

    const op = this.state.options;

    if (op === SHOW) {
      this.hideOptions();
    } else if (op === HIDDEN) {
      this.setState({ options: SHOW });
    }
  };

  hideOptions = () => {
    if (this.state.options === SHOW) {
      this.setState({ options: FADE }, () => delay(() => this.setState({ options: HIDDEN })));
    }
  };

  render() {
    return (
      <div className="page-root">
        <div className="triangula-page ta-game-page" style={{ backgroundImage: Background }} onClick={this.handleClick}>
          <TopBar />
          <Board ref={this.board} />
          {this.props.showLeaders === HIDE ? null : <Leaderboard />}
        </div>
        <Options op={this.state.options} hideOptions={this.hideOptions} />
        <Toolbar board={this.board} onClickOptions={this.handleOptions} hideOptions={this.hideOptions} />
        {this.props.showLeaders === HIDE ? (
          <>
            <BackButton />
            <HomeButton />
          </>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  {
    updateStats,
    requestSurrender,
    requestResetStats,
  }
)(GamePage);
